import { PlayerSwap } from "@/api/privateRequests/sbcs/player-swap";
import { cn } from "@/lib/utils";
import { BREAKPOINTS } from "@/settings";
import { ForwardRefRenderFunction, forwardRef } from "react";
import { useMediaQuery } from "usehooks-ts";

import { PlayerCardView } from "./PlayerCardView";

type SwapViewProps = {
  players: PlayerSwap[];
  onClick: (player: PlayerSwap, index: number) => void;
  index: number;
};

const SwapView: ForwardRefRenderFunction<HTMLDivElement, SwapViewProps> = (
  { players, onClick, index },
  ref,
) => {
  const onSwap = (swapIndex: number) => {
    onClick(players[swapIndex], index);
  };

  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE.query);

  const swappedPlayers = Object.values(players)?.map((player, i) => {
    return (
      <div
        className="desktop:scale-[0.95] sb-large:scale-[0.95] translate-y-[10%] desktop:translate-y-[0%] cursor-pointer"
        key={i}
      >
        <PlayerCardView
          player={player}
          hide_pos_base={"hidden"}
          onClick={() => onSwap(i)}
          selected={false}
        />
      </div>
    );
  });
  return (
    <div
      className={cn(
        "w-fit h-fit rounded-lg flex flex-row justify-between relative desktop:scale-[0.65] sb-large:scale-[0.95] bg-gray-900 shadow gap-1",
        isMobile && "px-2 py-1",
      )}
      ref={ref}
    >
      {swappedPlayers}
    </div>
  );
};

export default forwardRef(SwapView);
